
import { Component, Vue, Prop } from 'vue-property-decorator';
import { showCommonDialog, hideCommonDialog } from '@tencent/wphk-act-base-ui';
import { ActCycleConfig } from './types';
import { windowHelper, CustomException } from '@tencent/ppd-base-libs';
import { to } from '@tencent/wphk-base-utils';
import { getConf, getDialogContent } from './business';

@Component({
  name: 'ActCycleDialog',
})
export default class ActCycleDialog extends Vue {
  /** 业务名称，需与配置中心配置的名称一致 */
  @Prop({ default: '' }) business!: string;
  /** 若外部传入config，则使用外部config。 */
  @Prop({ default: null }) config?: ActCycleConfig;
  /** 若外部未传入config，则根据 business 手动初始化config. 需设置为 null，否则会丢失响应式 */
  private innerConfig: ActCycleConfig | null | undefined = null;

  async mounted() {
    /** 初始化配置 */
    this.innerConfig = await this.getConfig();
    /** 显示弹窗 */
    this.showDialog();
  }

  /** 拉取配置 */
  async getConfig() {
    // 如果有配置，则直接返回
    if (this.config) return this.config;
    // 如果没有配置，则自动进行拉取
    const [err, res] = await to(getConf({ business: this.business }));
    if (err) {
      throw new CustomException(err, 'ActOverGetConfigError', `business: ${this.business}`);
    }
    return res;
  }

  /** 显示弹窗 */
  showDialog() {
    if (!this.innerConfig) return;

    // 获取弹窗内容
    const dialogContent = getDialogContent(this.innerConfig);

    if (dialogContent) {
      const { content, btn, linkAdress } = dialogContent;
      showCommonDialog({
        weui: true,
        htmlContent: content,
        btns: [
          {
            text: btn,
            click: () => {
              this.$emit('onClick');
              // 存在链接则进行跳转
              if (linkAdress) {
                windowHelper.redirect(`${linkAdress}`, 200);
              } else {
                hideCommonDialog();
              }
            },
          },
        ],
      });
      /** 显示 */
      this.$emit('onShow');
    }
  }
}
